module.exports = __webpack_public_path__ + "static/media/javitott_meglevo_szamlacsoport2.8c71aa06.jpg";